import { render } from "./buyFeature.vue?vue&type=template&id=db786d40"
import script from "./buyFeature.vue?vue&type=script&lang=js"
export * from "./buyFeature.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/vokaladezful-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__